module.exports = __webpack_public_path__ + "static/media/luxhotels.2d3f480e.webp";